import { useSetting } from "@faire/retailer-visitor-shared/settings/__internal__/useSetting";
import { BATCH_10_LOGGED_OUT_PRODUCT_TILES_250603 } from "@faire/web-api--source/indigofair/settings/BATCH_10_LOGGED_OUT_PRODUCT_TILES_250603";
import { IFourVariantXP } from "@faire/web-api--source/indigofair/settings/IFourVariantXP";

import { useIsLoggedInRetailer } from "../lib/isLoggedInRetailer";

export const useSettingBatch10ProductTiles = () => {
  const isLoggedInRetailer = useIsLoggedInRetailer();
  const variant = useSetting(
    BATCH_10_LOGGED_OUT_PRODUCT_TILES_250603,
    IFourVariantXP.Bucket.CONTROL
  );
  return isLoggedInRetailer ? IFourVariantXP.Bucket.CONTROL : variant;
};
